import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-locize-backend'

const supportedLanguages = ['en', 'de', 'es', 'fr']
const shouldSaveMissing = import.meta.env.DEV && Boolean(import.meta.env.VITE_LOCIZE_API_KEY)

const locizeOptions = {
  projectId: import.meta.env.VITE_LOCIZE_PROJECT_ID,
  apiKey: shouldSaveMissing ? import.meta.env.VITE_LOCIZE_API_KEY : undefined,
  referenceLng: 'en',
  cdnType: 'pro',
}

i18n
  // i18next-locize-backend
  // loads translations from the project and saves missing keys in development
  // https://github.com/locize/i18next-locize-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    supportedLngs: supportedLanguages,
    load: 'languageOnly',
    fallbackLng: 'en',
    ns: ['web-play'],
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: locizeOptions,
    saveMissing: shouldSaveMissing,
    react: {
      useSuspense: false,
    },
  })

export default i18n
